<template>
  <div>
    <v-navigation-drawer v-model="drawer" shaped fixed temporary>
      <v-img :src="require('../../.././assets/PANTALLA-03.png')" background-size: contain>
      <v-img height="132px" :src="require('../../.././assets/logo.png')"></v-img></v-img>
      <v-list >
        <div class="name">{{ nombre}}</div>
        <v-list-item class="elevation-5 pt-3 text-center">
          <v-list-item-title  >
            <p class="title ">
              REGISTRAR INICIO TURNO
            </p>
          </v-list-item-title>
        </v-list-item>
      </v-list>

      <v-list nav dense>
        <v-list-item-group v-model="selectedItem" color="blue darken-4">
          <v-list-item v-for="item in admins" :key="item.text" :to="item.link">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>


    </v-navigation-drawer>
    <v-toolbar style="background: #1b4695" dense>
      <v-app-bar-nav-icon
        @click.stop="drawer = !drawer"
        style="color: #294697"
      ></v-app-bar-nav-icon>
      <v-toolbar-title class="mr-5 align-center" style="color: white">
        <span class="title">Registro inicio turno Punto de Venta</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn text dark id="no-background-hover"  small to="/">
        <span>Inicio</span>
        <v-icon>mdi-home</v-icon>
      </v-btn>

    </v-toolbar>
    <v-main>
      <v-container>
        <v-layout justify-center align-center>
          <router-view to="children" />
        </v-layout>
      </v-container>
    </v-main>
  </div>
</template>

<script>
export default {
  data() {
    return {
      nombre: localStorage.getItem("nombre"),
      drawer: null,
      selectedItem: 0,
      admins: [
       // {
         // text: "REGISTRO VISITA",
         // icon: "mdi-fingerprint",
        //  link: "/visitasNew/Usuario",
        //},
        //{
          //text: "REPORTES",
          //icon: "mdi-chart-areaspline",
          //link: "/visitas-preventivas/admin/reportes",
        //},
      ],
      /*places: [
        {
          text: "Zonas",
          link: "/visitas-preventivas/admin/zonas",
          icon: 'mdi-map-marker-multiple'
        },
        {
          text: "Sub zonas",
          link: "/visitas-preventivas/admin/sub-zonas",
          icon : 'mdi-map-marker-minus'
        },
        {
          text: "Ubicaciones",
          link: "/visitas-preventivas/admin/ubicaciones",
          icon : 'mdi-map-marker-radius'
        },
      ],*/
      mini: false,
      right: null,
    };
  },
  methods: {
    /**
     * Metodo para cerrar sesión
     */
    logout() {
      
      this.$router.push(localStorage.getItem("homepage"));
    },
  },
};
</script>
<style scoped>
#no-background-hover::before {
   background-color: transparent !important;
}


</style>